const PROJECT_RATIO = 16;

const pxToRem = (px: number): RemSize => `${px / PROJECT_RATIO}rem`;

export default pxToRem;

type RemSize = `${number}rem`;
